export const readSubscriptionHasDummyPacks = false;

// addon_pack_id should match those in GET /addon_packs
export const subscriptionDummyPacks = [
    {
        id: 11,
        addon_pack_id: 1,
        quantity: 6,
        created_at: "Date",
        updated_at: "Date",
    },
    {
        id: 21,
        addon_pack_id: 3,
        quantity: 4,
        created_at: "Date",
        updated_at: "Date",
    },
    {
        id: 31,
        addon_pack_id: 5,
        quantity: 2,
        created_at: "Date",
        updated_at: "Date",
    },
];
